import React, { ReactNode } from "react";
import * as styles from "./popup-sheet-floating-button.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetFloatingButtonProps {
	style?: React.CSSProperties;
	className?: string;
	children: ReactNode;
}

/**
 * A wrapper component for positioning a floating button at the bottom-right of a popup sheet
 */
export default function PopupSheetFloatingButton(
	props: PopupSheetFloatingButtonProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.floatingButton, props.className)}
		>
			{props.children}
		</div>
	);
}
